const baseColors = {
    transparent: 'transparent',
    inherit: 'inherit',
    brand: {
        navy: '#150E3F',
        deepLavendar: '#7E4BBC',
        orange: '#F15852',
    },
    neutrals: {
        900: '#1F1F23',
        800: '#484851',
        700: '#6C6C7A',
        750: '#5B5B67',
        600: '#A0A0AB',
        500: '#BCBCC3',
        400: '#DBDBE0',
        300: '#E7E7E9',
        200: '#F1F1F3',
        100: '#F6F6F7',
        0: '#FFFFFF',
    },
    indigos: {
        900: '#2222C3',
        800: '#391EE6',
        500: '#492FF4',
        200: '#D7D7FE',
        100: '#EBEBFE',
    },
    greens: {
        900: '#064C1D',
        800: '#095D25',
        500: '#06742B',
        200: '#B1F6BD',
        100: '#D1FFD9',
    },
    yellows: {
        800: '#704D00',
        500: '#FFBF00',
        200: '#FFE38D',
        100: '#FFF1C7',
    },
    reds: {
        900: '#860329',
        800: '#9E002D',
        500: '#BF0338',
        400: '#E70545',
        200: '#FFCCD2',
        100: '#FFE6E9',
    },
    berries: {
        900: '#7A0E5F',
        800: '#8F136F',
        500: '#A3167F',
        200: '#F9D0E9',
        100: '#FAE9F3',
    },
    peaches: {
        900: '#702D09',
        800: '#83360D',
        500: '#9C4C2E',
        200: '#FCD4C6',
        100: '#FBEAE4',
    },
    deepLavanders: {
        900: '#522F7B',
        800: '#613990',
        500: '#7E4BBC',
        200: '#E1DAF0',
        100: '#F0EDF6',
    },
    yellowGreens: {
        900: '#394600',
        800: '#455300',
        500: '#5B6C00',
        200: '#D9E3BF',
        100: '#EBF3D5',
    },
    greenCyans: {
        900: '#004A40',
        800: '#00584C',
        500: '#007465',
        200: '#95F3E0',
        100: '#C7FBF0',
    },
    cyans: {
        900: '#004851',
        800: '#005661',
        500: '#02707E',
        200: '#A0EDFB',
        100: '#D5F5FB',
    },
    blueCyans: {
        900: '#004569',
        800: '#00527C',
        500: '#006A9E',
        200: '#C3E3FB',
        100: '#E3F1FB',
    },
};
export const colors = {
    ...baseColors,
    text: {
        inherit: baseColors.inherit,
        onDark: baseColors.neutrals[0],
        default: baseColors.neutrals[900],
        secondary: baseColors.neutrals[700],
        secondaryOnGray: baseColors.neutrals[750],
        primary: baseColors.indigos[500],
        primaryOnDark: baseColors.indigos[100],
        error: baseColors.reds[500],
        errorOnDark: baseColors.reds[100],
        warning: baseColors.yellows[800],
        success: baseColors.greens[500],
        activationOnDark: baseColors.greens[100],
    },
    textLoading: {
        inherit: baseColors.inherit,
        onDark: baseColors.neutrals[0],
        default: baseColors.neutrals[100],
        secondary: baseColors.neutrals[100],
        secondaryOnGray: baseColors.neutrals[500],
        primary: baseColors.indigos[100],
        primaryOnDark: baseColors.indigos[100],
        error: baseColors.neutrals[100],
        errorOnDark: baseColors.neutrals[100],
        warning: baseColors.neutrals[100],
        success: baseColors.neutrals[100],
        activationOnDark: baseColors.greens[100],
    },
    forms: {
        label: baseColors.neutrals[900],
        placeholder: baseColors.neutrals[700],
        placeholderActive: baseColors.neutrals[600],
        placeholderOnGray: baseColors.neutrals[750],
    },
    borders: {
        none: baseColors.transparent,
        default: baseColors.neutrals[400],
        form: baseColors.neutrals[700],
        primary: baseColors.indigos[500],
        primaryActive: baseColors.indigos[900],
        error: baseColors.reds[500],
        errorActive: baseColors.reds[900],
        activationActive: baseColors.greens[900],
    },
    outlines: {
        input: baseColors.indigos[500],
        default: baseColors.brand.deepLavendar,
    },
    shadows: {
        white: baseColors.neutrals[0],
        default: baseColors.neutrals[400],
        secondary: baseColors.neutrals[900],
        primary: baseColors.indigos[500],
        success: baseColors.greens[800],
        warning: baseColors.yellows[800],
        error: baseColors.reds[900],
        primaryDestructive: baseColors.reds[500],
        activation: baseColors.greens[500],
    },
    controls: {
        inherit: baseColors.inherit,
        default: baseColors.neutrals[900],
        primary: baseColors.indigos[500],
        primaryHover: baseColors.indigos[800],
        primaryActive: baseColors.indigos[900],
        secondary: baseColors.neutrals[200],
        secondaryOnGray: baseColors.neutrals[300],
        secondaryHover: baseColors.neutrals[400],
        secondaryActive: baseColors.neutrals[500],
        secondaryAccent: baseColors.indigos[100],
        subtle: baseColors.transparent,
        subtleHover: baseColors.neutrals[400],
        subtleActive: baseColors.neutrals[500],
        destructive: baseColors.reds[500],
        destructiveHover: baseColors.reds[800],
        destructiveActive: baseColors.reds[900],
        secondaryDestructive: baseColors.reds[100],
        subtleDestructive: baseColors.transparent,
        subtleDestructiveHover: baseColors.reds[500],
        subtleDestructiveActive: baseColors.reds[800],
        white: baseColors.neutrals[0],
        activation: baseColors.greens[500],
        activationHover: baseColors.greens[800],
        activationActive: baseColors.greens[900],
        notification: baseColors.reds[400],
    },
    skeletons: {
        primary: baseColors.indigos[100],
        destructive: baseColors.reds[100],
        secondary: baseColors.neutrals[500],
        secondaryActive: baseColors.neutrals[500],
        secondaryAccent: baseColors.neutrals[500],
        secondaryDestructive: baseColors.reds[200],
        secondaryOnGray: baseColors.neutrals[500],
        subtle: baseColors.neutrals[500],
        subtleDestructive: baseColors.reds[100],
        activation: baseColors.greens[100],
    },
    backgrounds: {
        none: baseColors.transparent,
        onGray: baseColors.neutrals[0],
        default: baseColors.neutrals[100],
        secondary: baseColors.neutrals[200],
        secondaryOnGray: baseColors.neutrals[300],
        accent: baseColors.indigos[100],
        success: baseColors.greens[100],
        warning: baseColors.yellows[100],
        error: baseColors.reds[100],
        dark: baseColors.neutrals[900],
    },
    accents: {
        backgroundBerry: baseColors.berries[100],
        textBerry: baseColors.berries[500],
        backgroundBerryOnGray: baseColors.berries[200],
        textBerryOnGray: baseColors.berries[800],
        backgroundPeach: baseColors.peaches[100],
        textPeach: baseColors.peaches[500],
        backgroundPeachOnGray: baseColors.peaches[200],
        textPeachOnGray: baseColors.peaches[800],
        backgroundDeepLavender: baseColors.deepLavanders[100],
        textDeepLavender: baseColors.deepLavanders[500],
        backgroundDeepLavenderOnGray: baseColors.deepLavanders[200],
        textDeepLavenderOnGray: baseColors.deepLavanders[800],
        backgroundYellowGreen: baseColors.yellowGreens[100],
        textYellowGreen: baseColors.yellowGreens[500],
        backgroundYellowGreenOnGray: baseColors.yellowGreens[200],
        textYellowGreenOnGray: baseColors.yellowGreens[800],
        backgroundGreenCyan: baseColors.greenCyans[100],
        textGreenCyan: baseColors.greenCyans[500],
        backgroundGreenCyanOnGray: baseColors.greenCyans[200],
        textGreenCyanOnGray: baseColors.greenCyans[800],
        backgroundCyan: baseColors.cyans[100],
        textCyan: baseColors.cyans[500],
        backgroundCyanOnGray: baseColors.cyans[200],
        textCyanOnGray: baseColors.cyans[800],
        backgroundBlueCyan: baseColors.blueCyans[100],
        textBlueCyan: baseColors.blueCyans[500],
        backgroundBlueCyanOnGray: baseColors.blueCyans[200],
        textBlueCyanOnGray: baseColors.blueCyans[800],
    },
};
//# sourceMappingURL=colors.js.map